// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"popularMetaregion-module__buttonsContainer__tyw22"};